import React from "react"
import { useRackets } from "../hooks"
import PropTypes from "prop-types"
import AmazonDatas from "../json/racket/amazon.json"

const Item = ({ slug }) => {
  const afid = process.env.GATSBY_MERCARI_AFID
  const { nodes: rackets } = useRackets()
  const racket = rackets.find(racket => racket.fields.slug.includes(slug))
  const AmazonData = AmazonDatas.find(x => x.ASIN === racket.frontmatter.asin)

  return (
    <div className="poppotennis-media">
      <div className="poppotennis-media__imgpart">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={AmazonData?.DetailPageURL}
        >
          <img
            alt=""
            src={AmazonData?.Images.Primary.Large.URL}
            width="160"
            height="160"
            loading="lazy"
            className="poppotennis-media__shadow"
          />
        </a>
      </div>
      <div className="poppotennis-media__infopart">
        {AmazonData ? (
          <div className="poppotennis-media__title">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={AmazonData.DetailPageURL}
            >
              {AmazonData.ItemInfo.Title.DisplayValue}
            </a>
          </div>
        ) : (
          ""
        )}
        {AmazonData ? (
          <div
            className="poppotennis-media__description"
            style={{ marginBottom: `8px` }}
          >
            {AmazonData.ItemInfo.ByLineInfo.Brand.DisplayValue}
          </div>
        ) : (
          ""
        )}
        <div className="post-specs-price-wrap">
          {AmazonData ? (
            <a
              className="poppotennis-media__btn __orange"
              target="_blank"
              rel="noopener noreferrer"
              href={AmazonData.DetailPageURL}
            >
              Amazon
            </a>
          ) : (
            ""
          )}
          {racket?.frontmatter?.rakuten ? (
            <a
              className="poppotennis-media__btn __red"
              target="_blank"
              rel="noopener noreferrer"
              href={racket.frontmatter.rakuten}
            >
              楽天
            </a>
          ) : (
            ""
          )}
          <a
            className="poppotennis-media__btn __mercari"
            href={`https://jp.mercari.com/search?keyword=${racket.frontmatter.brand} ${racket.frontmatter.year} ${racket.frontmatter.name} テニス&order=desc&sort=score&afid=${afid}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            メルカリ
          </a>
        </div>
      </div>
    </div>
  )
}

Item.propTypes = {
  slug: PropTypes.string.isRequired,
}

export default Item
